module.exports = __webpack_public_path__ + "img/error_icon.790ca6da.png";